export enum HelpChatRoles {
  user = 'user',
  assistant = 'assistant',
}
